import A1 from "../../Images/A1.png";
import A2 from "../../Images/A2.png";
import A3 from "../../Images/A3.png";
import A4 from "../../Images/A4.png";
import B1 from "../../Images/B1.png";
import B2 from "../../Images/B2.png";
import B3 from "../../Images/B3.png";
import B4 from "../../Images/B4.png";
import B5 from "../../Images/B5.png";
import B6 from "../../Images/B6.png";
import bgImage from "../../Images/CustomerFeedback.png";
import kotakLogo from "../../Images/kotak.png";
import peopleLogo from "../../Images/People.png";
import pvrLogo from "../../Images/PVR.png";
import SatisfactionLogo from "../../Images/Satisfaction.png";
import solveLogo from "../../Images/Solve.png";
import tiraLogo from "../../Images/tira.png";
import styles from "./CustomerFeedback.module.css";

import I1 from "../../Images/I1.png";
import I2 from "../../Images/I2.png";
import I3 from "../../Images/I3.png";

import f1 from "../../Images/f1.png";
import f2 from "../../Images/f2.png";

import playIcon from "../../Images/YouTube.png";



function CustomerFeedback() {
  return (
    <div className={styles.container}>
      {/* Hero Section */}
      <section className={styles.hero} style={{ backgroundImage: `url(${bgImage})` }}>
        <h1>What Our Clients Say About ToxBox</h1>
        <p>
          Real stories of how ToxBox is transforming customer engagement across industries.
        </p>
        <div className={styles.buttons}>
          <button className={styles.primaryBtn}>Request A Demo</button>
          <button className={styles.secondaryBtn}>Learn More</button>
        </div>
      </section>

      {/* Testimonials Section */}
      <section className={styles.testimonials}>
        <h2>What Our Client Say About ToxBox</h2>
        <p>
          Real Stories Of How ToxBox Is Transforming Customer Engagement Across Industries.
        </p>

        <div className={styles.cards}>
          {/* Card 1 */}
          <div className={styles.card}>
            <img src={pvrLogo} alt="PVR Cinemas" className={styles.logo} />

            <h3>“AI-driven personalized cinema experiences.”</h3>
            <ul>
              <li>Achieved 30% increase in customer loyalty</li>
              <li>Reduced query resolution time by 25%</li>
              <li>Improved personalized recommendations</li>
            </ul>
          </div>

          {/* Card 2 */}
          <div className={styles.card}>
            <img src={tiraLogo} alt="Tira" className={styles.logo} />
            <h3>“Smooth, end-to-end customer engagement.”</h3>
            <ul>
              <li>Streamlined customer support operations</li>
              <li>Enhanced cross-channel consistency</li>
              <li>Boosted agent productivity by 20%</li>
            </ul>
          </div>

          {/* Card 3 */}
          <div className={styles.card}>
            <img src={kotakLogo} alt="Kotak Life" className={styles.logo} />
            <h3>“Timely WhatsApp-based interactions.”</h3>
            <ul>
              <li>Increased customer satisfaction by 15%</li>
              <li>Enabled proactive customer service</li>
              <li>Delivered hyper-personalized experiences</li>
            </ul>
          </div>
        </div>
      </section>

      {/* Impact Numbers */}
      <section className={styles.impact}>
        <h2>Our Impacts In Numbers</h2>
        <div className={styles.impactCards}>
          <div className={styles.impactCard}>
            <img src={peopleLogo} alt="People" className={styles.logo} />
            <h3>+40%</h3>
            <p>Customer engagement increase.</p>
          </div>
          <div className={styles.impactCard}>
            <img src={solveLogo} alt="Solve" className={styles.logo} />
            <h3>95%</h3>
            <p>Faster Query Resolution.</p>
          </div>
          <div className={styles.impactCard}>
            <img src={SatisfactionLogo} alt="Satisfaction" className={styles.logo} />
            <h3>80%</h3>
            <p>Improved Customer Satisfaction.</p>
          </div>
        </div>
      </section>

      {/* Footer */}
      <section className={styles.footer}>
        <h2>Why Our Clients Love ToxBox</h2>
        <p>
          Experience The Difference With A Platform Designed For Unparalleled Customer Engagement.
        </p>
      </section>

      <section className={styles.features}>
      {/* Row 1 */}
      <div className={`${styles.row} ${styles.fromLeft}`}>
        <img src={A1} alt="AI-Powered Personalization" />
        <div className={styles.textBlock}>
          <h2>AI-Powered Personalization</h2>
          <p>
            Deliver unique experiences tailored to each customer with advanced AI
            algorithms, anticipating needs and preferences for true 1:1 engagement.
          </p>
          <button className={styles.learnMore}>Learn More</button>
        </div>
      </div>

      {/* Row 2 */}
      <div className={`${styles.row} ${styles.fromRight}`}>
        <div className={styles.textBlock}>
          <h2>Seamless Integration</h2>
          <p>
            Connect effortlessly across all your communication channels,
            ensuring a consistent and fluid customer journey from start to finish.
          </p>
          <button className={styles.learnMore}>Learn More</button>
        </div>
        <img src={A2} alt="Seamless Integration" />
      </div>

      {/* Row 3 */}
      <div className={`${styles.row} ${styles.fromLeft}`}>
        <img src={A3} alt="Transparent & Secure" />
        <div className={styles.textBlock}>
          <h2>Transparent & Secure</h2>
          <p>
            Rest assured with enterprise-grade security and transparent data
            handling, ensuring full compliance and customer trust.
          </p>
          <button className={styles.learnMore}>Learn More</button>
        </div>
      </div>

      {/* Row 4 */}
      <div className={`${styles.row} ${styles.fromRight}`}>
        <div className={styles.textBlock}>
          <h2>Measurable ROI</h2>
          <p>
            Track and demonstrate the tangible impact of your engagement
            strategies with comprehensive analytics and clear, quantifiable results.
          </p>
          <button className={styles.learnMore}>Learn More</button>
        </div>
        <img src={A4} alt="Measurable ROI" />
      </div>
    </section>

    <section className={styles.section}>    
      {/* Industry Leaders */}
      <h2 className={styles.heading}>Trust By Industry Leaders</h2>
      <div className={styles.logos}>
        <img src={B1} alt="PVR" />
        <img src={B2} alt="Inox" />
        <img src={B3} alt="Tira" />
        <img src={B4} alt="Eureka Forbes" />
        <img src={B5} alt="Kotak" />
        <img src={B6} alt="Pepperfry" />
      </div>

      {/* Transform Section */}
      <div className={styles.transformBox}>
        <h2>See How ToxBox Can Transform Your Business</h2>
        <p>
          Accelerate Your Growth With AI-Driven Insights, Seamless Integrations,
          And Industry-Specific Solutions. Toxbox Empowers Teams With Smart Automation,
          Real-Time Analytics, And Tools Designed To Scale Your Operations Effortlessly.
        </p>
        <div className={styles.buttons}>
          <button className={styles.primary}>Request A Demo</button>
          <button className={styles.secondary}>Learn More</button>
        </div>
      </div>

      {/* Valued Clients */}
      <h2 className={styles.heading}>Hear From Our Valued Clients</h2>
      <p className={styles.subtext}>
        Short Clips Highlighting Real-World Success And Satisfaction.
      </p>
      <div className={styles.clientCards}>
        <div className={styles.card}>
            <div className={styles.thumbnailWrapper}>
          <img src={I1} alt="Client 1" className={styles.thumbnail} />
          <img src={playIcon} alt="Play" className={styles.playIcon} />
          </div>
          <h3>Transforming Customer Support</h3>
          <p>
            Our Clients Share How Faster Response Times, Smarter Tools,
            And A Human Touch Changed The Way They Experience Support.
          </p>
          <span className={styles.client}>PVR Inox</span>
        </div>

        <div className={styles.card}>
            <div className={styles.thumbnailWrapper}>
          <img src={I2} alt="Client 2" className={styles.thumbnail} />
          <img src={playIcon} alt="Play" className={styles.playIcon} />
          </div>
          <h3>Achieving Hyper Personalization</h3>
          <p>
            Discover How Tailored Experiences, Data-Driven Insights,
            And Customer-First Thinking Are Helping Our Clients Connect Like Never Before.
          </p>
          <span className={styles.client}>Tira</span>
        </div>

        <div className={styles.card}>
            <div className={styles.thumbnailWrapper}>
          <img src={I3} alt="Client 3" className={styles.thumbnail} />
          <img src={playIcon} alt="Play" className={styles.playIcon} />
          </div>
          <h3>Boosting Operational Efficiency</h3>
          <p>
            See How Streamlined Processes, Smarter Automation,
            And Integrated Solutions Are Driving Transformation.
          </p>
          <span className={styles.client}>Eureka Forbes</span>
        </div>
      </div>

      {/* Success Stories */}
      <h2 className={styles.heading}>Our Customer Success Stories</h2>
      <p className={styles.subtext}>
        Discover How Business Achieve Remarkable Result With ToxBox
      </p>
    </section>

    <section className={styles.caseStudyCard}>
      {/* Left Section */}
      <div className={styles.left}>
        <img
          src={f1}
          alt="Eureka Forbes Logo"
          className={styles.logo}
        />
        <h2 className={styles.company}>Eureka Forbes</h2>
        <p className={styles.subtitle}>Consumer Applications</p>

        <div className={styles.section}>
          <h3 className={styles.heading}>Challenges</h3>
          <p className={styles.text}>
            "We Needed A Way To Provide Instant, Transparent Support To Our
            Customers Without Overwhelming Our Support Team."
          </p>
        </div>

        <div className={styles.section}>
          <h3 className={styles.heading}>Solution</h3>
          <p className={styles.text}>
            "Toxbox Implemented AI-Driven Chat And WhatsApp Automation, Enabling
            Us To Respond Instantly While Keeping Communication Personalized."
          </p>
        </div>

        <div className={styles.section}>
          <h3 className={styles.heading}>Result</h3>
          <p className={styles.text}>
            60% Faster Response Times, 40% Increase In Customer Satisfaction,
            Higher Loyalty And Repeat Interactions
          </p>
        </div>

        <div className={styles.buttons}>
          <button className={styles.successBtn}>Read More Success Stories</button>
          <button className={styles.demoBtn}>Request Your Personalized Demo</button>
        </div>
      </div>

      {/* Right Section */}
      <div className={styles.right}>
        <div className={styles.visuals}>
          <h3 className={styles.heading}>Visuals</h3>
          <img
            src={f2}
            alt="Visual Chart"
            className={styles.chart}
          />
        </div>

        <div className={styles.testimonial}>
          <h3 className={styles.heading}>Testimonial Video</h3>
          <div className={styles.videoWrapper}>
            <img
              src={I1}
              alt="Testimonial"
              className={styles.thumbnail}
            />
          </div>
        </div>
      </div>
    </section>
    </div>
  );
}

export default CustomerFeedback;
